<template>
    <confirm-modal
        title="Delete quitclaim"
        :value="value"
        confirm-button="Delete"
        cancel-button="Cancel"
        @cancel="cancel"
        @confirm="confirm"
    >
        <p>The selected quitclaims file will be deleted. Would you like to confirm?</p>
        <v-list>
            <v-list-item dense>
                <v-list-item-content>
                    {{ quitclaim.name }}
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </confirm-modal>
</template>

<script>
    import ConfirmModal from './confirm-modal';

    export default {
        name: 'DeleteQuitclaim',
        components: {ConfirmModal},
        props: ['value', 'quitclaim'],
        methods: {
            confirm() {
                this.$emit('confirm', this.quitclaim);
                this.$emit('input', false);
            },

            cancel() {
                this.$emit('input', false);
            },
        }
    };
</script>

<style scoped>

</style>
